import { useEffect, useState } from "react";
import axios from "axios";
// import { getUserData, userSession } from '../../services/auth';
// import IconButton from '@mui/material/IconButton';
// import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import BaseModal from '../baseModal'
import TextField from '@mui/material/TextField';
// import MenuItem from '@mui/material/MenuItem';
// import InputAdornment from '@mui/material/InputAdornment';
import { stacksApi, clientNetwork } from "../../lib/constants";
// import { UseGiftMessage } from "../../services/chime";
import ConfirmModal from "./ConfirmModal";
// import { currencies } from "../../lib/currency";
import { getUserData, authenticatedUserAddress } from "../../services/auth";

//Import Style
import "../baseModal/styles.scss"
import './style.scss';
import { Button, Card, CardMedia, Paper, Typography } from "@mui/material";
import { principalCV } from "@stacks/transactions/dist/clarity/types/principalCV";
import { NonFungibleConditionCode, createAssetInfo, makeStandardNonFungiblePostCondition, uintCV } from "@stacks/transactions";
import { useConnect } from "@stacks/connect-react";
import styled from "styled-components";
import { network } from '../../services/auth';

// const apiUrl = stacksApi + "/extended/v1/address/";

const StyledPaper = styled(Paper)(() => ({
    backgroundColor: 'transparent',
    height: "18rem",
    width: "100%",
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px'
}))

const NftTransferModal = ({ show, authedUser, nftId, setShow, contractId, imageUrl, userSettings }) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [recipient, setRecipient] = useState('');
    const [currentTxId, setCurrentTxId] = useState('');
    const [disabled, setDisabled] = useState(true);

    const { doContractCall } = useConnect();

    async function transfer() {
        try {
            //const postConditionAddress = getUserData().profile.stxAddress.testnet;
            const postConditionAddress = authenticatedUserAddress({ network: clientNetwork });
            console.log("p2 automagic networking: " + postConditionAddress)

            const postConditionCode = NonFungibleConditionCode.DoesNotOwn;
            const assetAddress = contractId.split('.')[0];
            const assetContractName = contractId.split('.')[1].split('::')[0];
            const assetName = contractId.split('::')[1];
            const tokenAssetId = uintCV(nftId);
            const nonFungibleAssetInfo = createAssetInfo(assetAddress, assetContractName, assetName);

            const postConditions = [makeStandardNonFungiblePostCondition(postConditionAddress, postConditionCode, nonFungibleAssetInfo, tokenAssetId)];
            const txOptions = {
                contractAddress: assetAddress,
                contractName: assetContractName,
                functionName: 'transfer',
                functionArgs: [uintCV(nftId), principalCV(authedUser), principalCV(recipient)],
                network,
                postConditions,
                onFinish: ({ txId }) => {
                    setCurrentTxId(txId);
                    setRecipient('');
                    setShowConfirmModal(true);
                },
            }
            await doContractCall(txOptions)
        } catch (error) {
            console.log(error)
        }
    }

    console.log(recipient)

    const handleChange = async (e) => {
        const { value } = e.target;
        let recipient_ddress = value;
        if (recipient_ddress.includes('.')) {
            try {
                const { address } = (await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/v1/names/${recipient_ddress}`)).data
                recipient_ddress = address
            } catch (error) {
                console.log(error);
            }
        }
        if (recipient_ddress.includes('SP')) {
            setRecipient(recipient_ddress);
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    };

    const handleClose = () => {
        setShow(false)
        setRecipient('');
        setCurrentTxId('');
    };

    useEffect(() => {
    }, [recipient, currentTxId, showConfirmModal])

    return (
        <BaseModal show={show} handleClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
            <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' }, }} noValidate autoComplete="off">
                <div id="gift-form-container">
                    <StyledPaper>
                        <Card
                            sx={{ height: '100%', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0)', borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}
                        >
                            <CardMedia
                                component="img"
                                alt="Sample Image"
                                sx={{ height: '13rem', objectFit: 'cover' }}
                                image={imageUrl}
                            />
                            <Typography variant="body2" className="nft-card-text">
                                #{nftId}
                            </Typography>
                        </Card>
                    </StyledPaper>

                    <TextField id="outlined-start-adornment" fullWidth name="recipient" label="Recipient" onBlur={handleChange} sx={{ m: 1, width: '25ch' }} InputProps={{ inputProps: { maxLength: 100, }, }} />
                    <Button className="button" disabled={disabled} variant="contained" onClick={transfer}>Send</Button>
                </div>
            </Box>
            <ConfirmModal show={showConfirmModal} setShow={setShowConfirmModal} txId={currentTxId} close={() => handleClose()} userSettings={userSettings} />
        </BaseModal>
    );
}

export default NftTransferModal;